<template>
  <div>
    <div class="app-header clearfix">
      <el-button type="primary" class="float-right" :disabled="!multiSelectedInvoiceList.length" @click="handleOpenInvoiceDialog()">开票</el-button>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="tableDataLoading"
      :data="tableData"
      :row-key="getRowKey"
      border
      stripe
      highlight-current-row
      class="w-full"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55" :reserve-selection="true" />
      <el-table-column prop="billName" label="单据名称" />
      <el-table-column prop="drawer" label="开票人" />
      <el-table-column prop="invoiceType" label="发票种类" />
      <el-table-column prop="customerName" label="客户名称" />
      <el-table-column prop="taxNumber" label="纳税人识别号" min-width="160" />
      <el-table-column prop="taxAmt" label="含税金额" />
      <el-table-column prop="taxFreeAmt" label="不含税金额" />
      <el-table-column prop="tax" label="税额" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span class="text-color-success">{{ scope.row.status }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件-->
    <div class="clearfix">
      <div class="pagination-container float-right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.pageNum"
          background
          :page-sizes="[10,20,40,60,100]"
          :page-size="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 发票弹窗 -->
    <el-dialog title="提示" :visible.sync="invoiceDialogVisible">
      <p>
        当前选中待开发票共
        <span class="px-2 text-xxs">{{ multiSelectedInvoiceList.length }}</span>条，是否确认开票？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="confirmBtnLoading" @click="handleConfirmInvoice()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getElectronicBlueWaitingList, createElectronicBlueInvoice } from "@/api/invoiceApi";
export default {
  data() {
    return {
      tableDataLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      multiSelectedInvoiceList: [], // 勾选开票
      getRowKey(row) {
        return row.lsh;
      },
      invoiceDialogVisible: false,
      confirmBtnLoading: false
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.tableDataLoading = true;
      getElectronicBlueWaitingList(this.listQuery).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.tableDataLoading = false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multiSelectedInvoiceList = [];
      if (val.length) {
        val.forEach(item => {
          this.multiSelectedInvoiceList.push(item.lsh);
        });
      }
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.fetchData();
    },
    handleOpenInvoiceDialog() {
      if (this.multiSelectedInvoiceList.length > 100) {
        this.$message.error("最多可选100条开票数据");
        return;
      }
      this.invoiceDialogVisible = true;
      this.confirmBtnLoading = false;
    },
    handleConfirmInvoice() {
      this.confirmBtnLoading = true;
      createElectronicBlueInvoice({ lshList: this.multiSelectedInvoiceList })
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success("开票成功");
            this.invoiceDialogVisible = false;
            this.fetchData();
            setTimeout(() => {
              this.$refs.multipleTable.clearSelection();
            }, 100); // 延迟清除全选勾选状态，避免用户肉眼看见勾选开票长度为0的情况
          } else {
            this.confirmBtnLoading = false;
          }
        })
        .catch(() => {
          this.confirmBtnLoading = false;
        });
    }
  }
};
</script>
